const Message = () => {

  const storedUser = localStorage.getItem("userInfo");

  const parsed = storedUser ? JSON.parse(storedUser) : null;
  const newQuery: Record<string, string> = parsed
    ? {
      // agency_id: parsed?.agency.id.toString(),
      employee_id: parsed?.employee_id.toString(),
      agency_id: Number(1122).toString(),
      agency_name: parsed?.agency?.agency_name.toString(),
      email_id: parsed?.email_id?.toString(),
      contact_no: parsed?.contact_no,
      uuid: parsed?.uuid.toString(),
      first_name: parsed?.first_name?.toString(),
      last_name: parsed?.last_name?.toString(),
      middle_name: parsed?.middle_name?.toString(),
      access_type: parsed?.access_type?.toString(),
      role: parsed?.employee_roles?.[0]?.role_name?.toString(),
      sso_id: parsed?.uuid.toString(),
    }
    : {};

  return (
    <div>
      <iframe
        // src={`http://localhost:8082/auth/login?${new URLSearchParams(newQuery).toString()}`}
        // * production url
        // src={`http://localhost:8081/auth/login?agency_id=1122&agency_name=Cogent+Infomedia&email_id=deepak%40cogentinfomedia.com&contact_no=8574524836&uuid=040053e9-811e-412f-9fe6-3f99b1a4ea55&first_name=Deepak&last_name=Kumar&sso_id=040053e9-811e-412f-9fe6-3f99b1a4ea55`}

        src={`https://lively-stone-05e56020f.2.azurestaticapps.net/auth/login?${new URLSearchParams(
          newQuery
        ).toString()}`}
        //* test url
        // src={`https://thankful-forest-005f54800.6.azurestaticapps.net/auth/login?${new URLSearchParams(newQuery).toString()}`} width="100%"
        width="100%"
        height="100%"
        style={{
          border: "none",
          position: "fixed",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
        }}
        title="Message Iframe"
        allow="microphone; autoplay"
        allowFullScreen
      />
    </div>
  );
};

export default Message;
